import {
  DeltafaktorBaustein,
  Produktlinie,
  TaasInfo,
  VermietetesObjektQuoteDB,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { Selbstbeteiligung, TaasRequestModel } from '@ps20/bff-models';
import { AngebotsId } from './angebotsId';

export interface QuoteDbSpartePayload<T> {
  angebotsId: AngebotsId;
  taasSparteRequestModel: TaasRequestModel<T>;
  selectedProduktlinie: Produktlinie;
  alleProduktlinien: Array<Produktlinie>;
  selbstbeteiligung: Selbstbeteiligung;
  gesamtpreis: number;
  gesamtpreisMitRabatt?: number;
  vertragslaufzeit: number;
  geschaeftsfuehrer?: boolean;
  antragsnummer?: string;
  vermietetesObjekt?: Array<VermietetesObjektQuoteDB>;
  sparteErsatzInfo?: QuoteDbSparteErsatzInfo;
}

export interface QuoteDbSparteErsatzInfo {
  deltafaktoren: Array<DeltafaktorBaustein>;
  kuendigungLiegtVor: boolean;
  vorgangsId?: string;
  salesProdukt?: string;
  kurzbezeichnung?: string;
}

export function getInfosFromDeltafaktoren(
  taasInfo: TaasInfo,
  vertragsoptionen: Vertragsoptionen,
  quoteDbPayload: QuoteDbSpartePayload<unknown>,
): void {
  if (taasInfo.deltafaktoren) {
    quoteDbPayload.sparteErsatzInfo = {
      deltafaktoren: taasInfo.deltafaktoren.deltafaktoren,
      kuendigungLiegtVor: vertragsoptionen.vorvertragGekuendigt,
      vorgangsId: taasInfo.deltafaktoren.vorgangsId,
      salesProdukt: taasInfo.deltafaktoren.salesProdukt,
    };
  }
  if (quoteDbPayload.sparteErsatzInfo) {
    quoteDbPayload.sparteErsatzInfo.kurzbezeichnung = vertragsoptionen.kurzbezeichnung;
  }
}
